module.exports = __webpack_public_path__ + "img/60f1.a7ded650.jpg";